export { default as FAQ } from './ui/FAQ';
export type { IFAQ } from './type/faqType';
